import './../../scss/blocks/_map.scss'
import loadYandexMaps from './../components/map'

document.addEventListener('DOMContentLoaded', () => {
    loadYandexMaps()
})
